import React from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { Col, DatePicker, Input, Radio, Row } from "antd";
import { ProfileKosong } from "../../../../../../asset";
import { getNameImage } from "../../../../../../util/Util";
import moment from "moment";

const DriverProfileOwned = ({ form }) => {
  return (
    <div className="columns mt-5">
      <SubTitleTab title="Driver Photo (Optional)" />
      <div className=" bg-gray-1000 border-dashed border-2 border-sky-500 p-5 rounded-md">
        <div className="border-solid border-2 border-sky-500 w-full p-4 rounded-md">
          <Row>
            <Col span={6}>
              <img
                className="h-32 w-32 py-2"
                src={form?.driver_photo ? form?.driver_photo : ProfileKosong}
                alt="driver_photo"
              />
            </Col>
            <Col
              span={18}
              style={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <p className=" absolute top-[45%]">
                {form?.driver_photo
                  ? getNameImage(form?.driver_photo)
                  : "tidak ada foto"}
              </p>
            </Col>
          </Row>
        </div>
      </div>

        <div className="container-field">
          <SubTitleTab title="Employee ID" />
          <Input
            size="large"
            value={form?.employee_id ? form?.employee_id : "-"}
            disabled
          />
        </div>

      <div className="container-field">
        <SubTitleTab title="Title (Optional)" />
        <Input
          size="large"
          value={form?.title ? form?.title : "-"}
          disabled
        />
      </div>
      <div className="container-field">
        <SubTitleTab title="First Name" />
        <Input
          size="large"
          value={form?.first_name ? form?.first_name : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Last Name" />
        <Input
          size="large"
          value={form?.last_name ? form?.last_name : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="ID Card/NIK (Optional)" />
        <Input
          size="large"
          value={form?.nik ? form?.nik : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Phone" />
        <Input
          size="large"
          value={form?.phone ? form?.phone : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Email" />
        <Input
          size="large"
          value={form?.email ? form?.email : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Marital Status (Optional)" />
        <Input
          size="large"
          value={form?.marital_status ? form?.marital_status : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Gender (Optional)" />
        <Radio.Group value={form?.gender} style={{ color: "#CF0000" }} disabled>
          <Radio value="L" className=" font-roboto-medium text-[20px]">
            Male
          </Radio>
          <Radio value="P" className=" font-roboto-medium text-[20px]">
            Female
          </Radio>
        </Radio.Group>
      </div>

      <div className="container-field">
        <SubTitleTab title="Birthplace (Optional)" />
        <Input
          size="large"
          value={form?.birth_place ? form?.birth_place : "-"}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Birthdate (Optional)" />
        <DatePicker
          size="large"
          format="DD MMMM YYYY"
          value={
            form?.birth_date && form?.birth_date !== "0001-01-01"
              ? moment(form?.birth_date)
              : null
          }
          disabled
        />
      </div>

      <TitleTab title="Emergency Contact" />

      <div className="container-field">
        <SubTitleTab title="Name" />
        <Input
          size="large"
          value={
            form?.emergency_contact_name ? form?.emergency_contact_name : "-"
          }
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Relationship (Optional)" />
        <Input
          size="large"
          value={
            form?.emergency_contact_relationship
              ? form?.emergency_contact_relationship
              : "-"
          }
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Phone" />
        <Input
          size="large"
          value={
            form?.emergency_contact_no_hp ? form?.emergency_contact_no_hp : "-"
          }
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Address" />
        <Input
          size="large"
          value={
            form?.emergency_contact_address
              ? form?.emergency_contact_address
              : "-"
          }
          disabled
        />
      </div>
    </div>
  );
};

export default DriverProfileOwned;
